<!--这是web的svg浏览组件,svg图只能放在static/svgFile路径下-->
<template>
	<div class="framediv" ref="maxwindow">
		<iframe ref="dialogSvgframe" id="dialogSvgFrame" style="width:100%;height:100%;"></iframe>
	</div>
</template>
<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: ['svgpath'],
		data() {
			return {
				ids: [],
				nowScale: 10, //当前缩放倍率
				svgUrl:"",
				pictLoading: true
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			var svgframe = this.$refs.dialogSvgframe
			svgframe.addEventListener('load', () => {
				setTimeout(() => {
					this.getNowIds()
				}, 5000);
			})
			addNewTask('webDialogSvgRefreshData', 0, 3000, -1, () => {})
		},
		destroyed() {
			removeTask("webDialogSvgRefreshData")
			this.realTimeValueStore.commit("removeKeys", this.ids)
		},
		computed: {
			getResourcesByName() {
				return name => {
					return resourcesStore.getters.getResourcesByName(name)
				}
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			valueList() {
				return this.realTimeValueStore.getters.getValue(this.ids)
			}
		},
		watch: {
			svgpath(nv, ov) {
				this.svgUrl = "/static/svgFile/" + nv
				this.$refs.dialogSvgframe.contentWindow.location.replace(this.svgUrl)
				setTimeout(() => {
					this.pictLoading = false
					/*this.getNowIds()*/
					this.getPicSize()
				}, 3000);
			},
			ids(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
			},
			valueList(nv, ov) {
				this.getMacRealValueCallback(nv)
				this.getPicSize()
			}
		},
		methods: {
			getNowIds() {
				//获取当前变量列表
				let svgframe = document.getElementById("dialogSvgFrame")
				if(svgframe == undefined || svgframe.contentDocument == undefined) {
					return
				}
				//获取svg内容对象
				var svg = svgframe.contentDocument.documentElement
				//重新获取IDS
				var ids = []
				var devices = svg.getElementsByTagName('text')
				for(var i = 0; i < devices.length; i++) {
					var item = devices[i].getAttribute('DeviceNo')
					if(!isempty(item)) {
						ids.push(item)
					}
				}
				var uses = svg.getElementsByTagName('use')
				for(var i = 0; i < uses.length; i++) {
					var item = uses[i].getAttribute('DeviceNo')
					if(!isempty(item)) {
						ids.push(item)
					}
				}
				this.ids = ids
			},
			resetSize() {
				//缩放到指定倍率大小
				let svgframe = document.getElementById("dialogSvgFrame")
				if(svgframe == undefined || svgframe.contentDocument == undefined) {
					return
				}
				//获取svg内容对象
				var svg = svgframe.contentDocument.documentElement
				let width = svgframe.offsetWidth
				let height = svgframe.offsetHeight
			},
			getMacRealValueCallback(values) {
				var doc = document.getElementById("dialogSvgFrame").contentDocument.getElementsByTagName("svg")[0]
				var devices = doc.getElementsByTagName('text')
				var uses = doc.getElementsByTagName('use')
				this.ids.forEach((item, index) => {
					var value = values[index]
					if(value != undefined) {
						value = value.split(':')[0]
					}
					if(value == undefined) {
						return
					}
					//找到元素,赋值
					for(var i = 0; i < devices.length; i++) {
						if(devices[i].getAttribute('DeviceNo') == item) {
							var fm = devices[i].getAttribute("format");
							if(isempty(fm)) {
								fm = "#0.00"
							}
							//一般是#0.00这样的，有时候会加单位在后面，我们要把#0.00部分其替换成值
							if(fm.indexOf("#0.") != -1) {
								var len = fm.length - 3
								for(var j = 0; j < fm.length - 3; j++) {
									if(fm.charAt(j + 3) != '0') {
										len = j
										break
									}
								}
								fm = fm.substring(len + 3)
								value = parseFloat(value).toFixed(len) + fm
							}
							devices[i].textContent = isempty(value) ? "--" : value
						}
					}
					for(var i = 0; i < uses.length; i++) {
						if(uses[i].getAttribute('DeviceNo') == item) {
							//样式，不为0就在后面加上状态
							var link = uses[i].getAttribute("xlink:href")
							//缓存的上一次状态
							var state = uses[i].getAttribute("state")
							if(state != 0) {
								//移除一下原来的样式
								link = link.substring(0, link.lastIndexOf(state))
							}
							var newState = parseInt(value)
							//刷新图符样式
							if(newState != 0) {
								link = link + newState
							}
							uses[i].setAttribute("xlink:href", link)
							uses[i].setAttribute("state", newState)
						}
					}
				})
			},
			//获取图形大小
			getPicSize() {
				var doc = document.getElementById("dialogSvgFrame").contentDocument.getElementsByTagName("svg")[0]
				let svgframe = document.getElementById("dialogSvgFrame")
				var devices = doc.getElementsByTagName('rect')
				let width = doc.width.animVal.value
				let height = doc.height.animVal.value
				if(width > 1000) {
					width = 1000
				}
				if(height > 600) {
					height = 600
				}
				this.$emit('widthAndHeight', width, height)
				if(svgframe == undefined || svgframe.contentDocument == undefined) {
					return
				}
				//获取svg内容对象
				var svg = svgframe.contentDocument.documentElement
				svg.setAttribute("width", width)
				svg.setAttribute("height", height)
			},
		}
	}
</script>

<style scoped>
	.rotate {
		position: absolute;
		transform: rotate(90deg);
	}
	
	.framediv {
		overflow: hidden;
		position: relative;
	}
	
	.zoonContainer {
		position: absolute;
		width: 40px;
		right: 80px;
		top: 60px;
	}
	
	.zoonContainer>div {
		background: rgba(0, 0, 0, 0.1);
	}
	
	.zoon {
		cursor: pointer;
		width: 30px;
		padding: 5px;
		height: 30px;
		box-shadow: 0 0 5px silver;
	}
	
	.zoonOut {
		margin-top: 10px;
	}
</style>